import { render, staticRenderFns } from "./get_access.vue?vue&type=template&id=00098608"
import script from "./get_access.vue?vue&type=script&lang=js"
export * from "./get_access.vue?vue&type=script&lang=js"
import style0 from "./get_access.vue?vue&type=style&index=0&id=00098608&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports